import {LayoutAnimation, View} from "react-native";
import {useKeyboard} from "../utils";

export const ShownWithKeyboardView = () => {
    const isShownKeyboard = useKeyboard()

    LayoutAnimation.configureNext({
        duration: 250,
        update: {
            duration: 250,
            type: 'keyboard',
        }
    })

    return (
        <View style={{height: (isShownKeyboard ? 210 : 0)}} />
    )
}
